export default "__VITE_ASSET__BSF$$EC9__"